/**
 * DET SPILLESTEDET HAR DELT, SLIK MOTTAKEREN SER DET (F18, runde 4. oktober).
 *
 * Salens spesifikasjon og arrangementet deles med eksterne (innlogget). De åpnes ikke på husets
 * egne sider — salens side bærer leie, mannskapsmal og synlighet, og arrangementet budsjett og
 * avvik — men som et lesedokument fra `GET /v1/me/shares/:grantId/view`, bygget av en
 * definer-funksjon som bare svarer mottakeren av en levende deling.
 *
 * Salen er det samme dokumentet arrangøren og byrået leser i advancen (`app.room_spec_doc`), så
 * spesifikasjonen er ett svar uansett hvem som spør. Leien finnes ikke i det.
 */
import { z } from 'zod';

import { productionRoomSpecSchema } from './production-advance.js';
import { venueNightStatusSchema } from './venues.js';

const instant = z.iso.datetime({ offset: true });

export const sharedVenueNightSchema = z
  .object({
    title: z.string().nullable(),
    artistName: z.string().nullable(),
    nightOn: z.iso.date(),
    getInAt: instant.nullable(),
    doorsAt: instant.nullable(),
    curfewAt: instant.nullable(),
    /* Hele stigen (QA15-S C4, 1185): kvelden kan deles mens den er Forespurt eller Hold. */
    status: venueNightStatusSchema,
    roomName: z.string(),
    venueName: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    timeZone: z.string(),
  })
  .meta({ id: 'SharedVenueNight' });
export type SharedVenueNight = z.infer<typeof sharedVenueNightSchema>;

/** Én av de to er satt, etter `objectType`. Et objekt og ikke en union: DTO-en er en klasse. */
export const sharedVenueViewSchema = z
  .object({
    objectType: z.enum(['venue_room', 'venue_night']),
    organizationName: z.string(),
    room: productionRoomSpecSchema.nullable(),
    night: sharedVenueNightSchema.nullable(),
  })
  .meta({ id: 'SharedVenueView' });
export type SharedVenueView = z.infer<typeof sharedVenueViewSchema>;

/** Typene som åpnes som et lesedokument, ikke som husets egen side i gjestemodus. */
export const SHARED_VENUE_TYPES = ['venue_room', 'venue_night'] as const;
export function isSharedVenueType(type: string): type is (typeof SHARED_VENUE_TYPES)[number] {
  return (SHARED_VENUE_TYPES as readonly string[]).includes(type);
}
